import { formatMessage, type MessageValues } from "./format-message";
import { en, type MessageKey, type Messages } from "./messages/en";

export type Translate = (key: MessageKey, values?: MessageValues) => string;

function lookup(messages: Messages, key: string): string | undefined {
    let node: unknown = messages;
    for (const part of key.split(".")) {
        if (!node || typeof node !== "object") return undefined;
        node = (node as Record<string, unknown>)[part];
    }
    return typeof node === "string" ? node : undefined;
}

/**
 * The `t` function for one locale. A key missing from the catalogue falls back to English, then to the
 * key itself, so a gap is visible and never blank (the completeness test keeps gaps out of the repository).
 */
export function createTranslate(locale: string, messages: Messages): Translate {
    return (key, values) => formatMessage(lookup(messages, key) ?? lookup(en, key) ?? key, values, locale);
}

/** English, for the pure helpers and tests that take an optional `t`: `(…, t: Translate = defaultT)`. */
export const defaultT: Translate = createTranslate("en", en);
